var PAGER_ARROW_SIDES = ['prev', 'next'];

export { PAGER_ARROW_SIDES };
